function createElement(tagName, options) {
    var node = document.createElement(tagName, options);
    node.setAttribute('data-zv', "8.0.0");
    return node;
}
export default createElement;
